import React from "react";
import { useNavigate, Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { getAuth } from "firebase/auth";

function Recruiters() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
    if (auth.currentUser) {
      navigate("/");
    } else {
      navigate("/getstarted");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>

      <SEOHead
        title="Hiring Platform for Recruiters & Employers (2026)"
        description="Discover how EmployPilot helps recruiters and employers find better candidates through smarter tools, AI-driven insights, and a growing talent ecosystem."
        canonical="https://employpilot.com/recruiters"
      />

      <h1>Smarter Hiring Starts with Better Candidates</h1>

      <p style={{ fontSize: "18px", color: "#555" }}>
        Hiring the right candidate is harder than ever. Recruiters and employers need tools that go beyond resumes and provide real insight into candidate potential.
      </p>

      <p style={{ fontWeight: "bold", marginTop: "15px" }}>
        EmployPilot is building a smarter ecosystem where candidates are better prepared—and easier to evaluate.
      </p>

      <button onClick={handleStart} style={btnPrimary}>
        Explore the Platform
      </button>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Why Traditional Hiring Falls Short</h2>

      <ul>
        <li>❌ Resumes don’t tell the full story</li>
        <li>❌ Candidates are often underprepared</li>
        <li>❌ Screening takes too much time</li>
        <li>❌ Lack of real performance insight</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>How EmployPilot Changes Hiring</h2>

      <ul>
        <li>✔ Candidates arrive better prepared</li>
        <li>✔ AI-assisted resume and interview readiness</li>
        <li>✔ Improved candidate quality over time</li>
        <li>✔ A growing ecosystem of engaged users</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Built for the Future of Hiring</h2>

      <p>
        EmployPilot is not just a tool—it’s a system designed to improve how candidates prepare and how recruiters evaluate talent.
      </p>

      <p>
        As the platform grows, recruiters benefit from a pipeline of candidates who are actively improving their skills, resumes, and interview readiness.
      </p>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Opportunities for Recruiters</h2>

      <ul>
        <li>✔ Access to a growing pool of motivated candidates</li>
        <li>✔ Better-prepared applicants</li>
        <li>✔ Potential future integrations and partnerships</li>
        <li>✔ Data-driven hiring insights (future roadmap)</li>
      </ul>

      {/* INTERNAL LINKS */}
      <p style={{ marginTop: "20px" }}>
        See how candidates prepare:{" "}
        <Link to="/ai-resume-builder">
          AI Resume Builder
        </Link>
      </p>

      <p>
        Explore interview preparation tools:{" "}
        <Link to="/ai-interview-coach">
          AI Interview Coach
        </Link>
      </p>

      <p>
        Learn how users improve their careers:{" "}
        <Link to="/ai-career-advisor">
          AI Career Advisor
        </Link>
      </p>

      {/* COMMUNITY CTA */}
      <p style={{ marginTop: "30px" }}>
        Want to see real candidate discussions?{" "}
        <strong>Explore the EmployPilot Community</strong> and understand how users are preparing for jobs.
      </p>

      <p style={{ fontSize: "14px", color: "#777" }}>
        (Free account required)
      </p>

      <Link to="/community">
        View the Community
      </Link>

      {/* CTA */}
      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <h2>Be Part of the Future of Hiring</h2>

        <button onClick={handleStart} style={btnSuccess}>
          Get Started
        </button>
      </div>

      {/* FAQ */}
      <h2 style={{ marginTop: "60px" }}>
        Frequently Asked Questions
      </h2>

      <h3>How can EmployPilot help recruiters?</h3>
      <p>
        By improving candidate readiness, EmployPilot helps recruiters connect with more qualified and prepared applicants.
      </p>

      <h3>Is EmployPilot a job board?</h3>
      <p>
        No. It is a career development platform designed to improve candidate quality before they apply.
      </p>

      <h3>Can recruiters partner with EmployPilot?</h3>
      <p>
        Future opportunities for partnerships and integrations are part of the platform’s roadmap.
      </p>
<div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "12px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer"
};

export default Recruiters;